import _uniqueId from "lodash/uniqueId";
import { CHECK_EXERCISE } from '../types';
const checkExercise = (exerciseId, message, success, groupedItems) => ({
  groupedItems,
  id: exerciseId,
  message,
  messageId: _uniqueId(),
  success,
  type: CHECK_EXERCISE
});
export default checkExercise;